/* eslint-disable import/no-default-export */
import { IconName } from 'app/common/components/controls';
import { removeRecentBoardByID } from 'app/gamma/src/modules/state/ui/boards-menu';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'app/gamma/src/types';
import styles from './CloseBoardButton.less';
import { BoardButton } from './BoardButton';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('board_list_item');

interface OwnProps {
  readonly idBoard: string;
  readonly tabIndex?: number;
}

interface DispatchProps {
  onClick(): void;
}

interface AllProps extends OwnProps, DispatchProps {}

class CloseBoardButtonUnconnected extends React.Component<AllProps> {
  onClickHandler: React.MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick();
  };

  render() {
    const { tabIndex } = this.props;

    return (
      <BoardButton
        className={styles.closeButton}
        icon={IconName.Close}
        onClick={this.onClickHandler}
        tabIndex={tabIndex}
        title={format('click-to-remove-this-board-from-your-recent-boards')}
      />
    );
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: OwnProps,
): DispatchProps => {
  const { idBoard } = ownProps;

  return {
    onClick() {
      /**
       * MS Edge has an issue with racing conditions in React, or
       * with the way async/await works, or both.
       * With optimistic updates happening here, it seems
       * that React is too fast to unbind callbacks, and Edge lets
       * the click go through a then unbound <a> on RouterLink.
       *
       * A setTimeout here fixes the problem.
       *
       * TODO: Remove this when EdgeHTML is not supported anymore
       */
      setTimeout(() => {
        dispatch(removeRecentBoardByID(idBoard));
      });
    },
  };
};

export const CloseBoardButton = connect(
  null,
  mapDispatchToProps,
)(CloseBoardButtonUnconnected);
